export default "__VITE_ASSET__7GepNBOp__"